<script setup lang="ts" name="ModalG2OSelectedList">
const { title } = defineProps<{
  title: string;
}>();
</script>

<template>
  <div>
    <p class="mb-2 text-subtitle-2 text-charcoal-9">
      {{ title }}
    </p>
    <slot />
  </div>
</template>
